import { Signal, signal, effect } from '@angular/core';

export function createDelayedLoadingSignal(source: Signal<boolean>, delayMs = 1000) {
    const delayed = signal(false);
    let timeout: ReturnType<typeof setTimeout> | undefined;

    effect(
        () => {
            const loading = source();

            if (loading) {
                clearTimeout(timeout);
                delayed.set(true);
            } else {
                timeout = setTimeout(() => {
                    delayed.set(false);
                }, delayMs);
            }
        },
        { allowSignalWrites: true }
    );

    return delayed.asReadonly();
}
